module.exports = __webpack_public_path__ + "static/media/rchic.55b2c1a6.png";